import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"
import React, { useState, useEffect, useContext } from "react"
import Container from "react-bootstrap/Container"
import Card from "react-bootstrap/Card"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import defaultAvatar from "assets/avatar.png"
import UserContext from "services/UserContext"
import API_HOST from "services/api"
import ImageManager from "components/ImageManager"
import ClientContext from "services/ajax"
import { SubscriptionProduct } from "./Subscribe"

export default function Profile() {
    const {
        user,
        setUser
    } = useContext(UserContext)
    const { uploadImage, getRelatedImages, updateUser, deleteImage, getUserSubscription, getUserPaymentMethods } = useContext(ClientContext)

    const [images, setImages] = useState([{preview: defaultAvatar}])
    const [name, setName] = useState(user?.name)
    const [avatar, setAvatar] = useState(user?.avatar)
    const [subsciptions, setSubscriptions] = useState([])
    const [paymentMethods, setPaymentMethods] = useState([])

    useEffect(() => {
        getUserSubscription().then((subscriptions) => {
            setSubscriptions(subscriptions)
        })
        getUserPaymentMethods().then((paymentMethods) => {
            setPaymentMethods(paymentMethods)
        })
    }, [])

    const onChange = (imageList) => {
        setImages(imageList)
    }

    const onImageSelect = async (index) => {
        const image = images[index]
        if (image.file) {
            // we need to upload it first
            const i = await uploadImage(image.file, user.id)
            setAvatar(`${API_HOST}/api/image/_d/${i.owner_id}/${i.id}.${i.original_name.split(".").slice(-1)[0]}`)
        } else {
            setAvatar(images[index].preview)
        }
        images.forEach(i => delete i.selected)
        images[index].selected = true
        setImages(images)
    }

    const removeImage = (index) => {
        const image = images[index]
        const id = image.preview.split("/").slice(-1)[0].split(".")[0]
        deleteImage(id).then(() => {
            setAvatar(avatar)
        })
    }

    useEffect(() => {
        getRelatedImages(user.id).then((images) => {
            const i = images.map(i => {
                const url = `${API_HOST}/api/image/_d/${i.owner_id}/${i.id}.${i.original_name.split(".").slice(-1)[0]}`
                return {
                    preview: url,
                    selected: url === avatar
                }
            })
            i.unshift({preview: defaultAvatar, selected: defaultAvatar === avatar})
            setImages(i)
        })
    }, [user?.id, avatar])

    const selectionSaved = user.avatar !== avatar ? "warning" : "success"
    const onSave = async () => {
        const uploads = images.filter(i => i.file).map(({file}) => uploadImage(file, user.id))
        Promise.all(uploads).then(() => {
            updateUser(name, avatar).then((_user) => {
                const newUser = {...user, ..._user}
                sessionStorage.setItem("user", JSON.stringify(newUser))
                setUser(newUser)
            })
        })
    }

    return (<Container>
        <Form className="vstack gap-3">
            <Row>
                <Col>
                    <Form.Group>
                        <Form.FloatingLabel>Display Name</Form.FloatingLabel>
                        <Form.Control type="text" defaultValue={name} onChange={({target}) => setName(target.value)}></Form.Control>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Group>
                        <Form.Label>Avatar:</Form.Label>
                        <ImageManager onChange={onChange} onImageSelect={onImageSelect} images={images} removeImage={removeImage} selectionSaved={selectionSaved}/>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Button onClick={onSave}>Save</Button>
                </Col>
            </Row>
            <Row>
                <Col>
                    <h1>Subscriptions</h1>
                    {subsciptions.map((s) => {
                        const product = s.stripe.product
                        product.prices = [s.stripe.price]
                        return <SubscriptionProduct key={s.id} product={s.stripe.product}/>
                    })}
                </Col>
                <Col>
                    <h1>Payment Methods</h1>
                    {paymentMethods.map((p) => {
                        return <Card key={p.id}>
                            <Card.Header>
                                <h3>{p.card.brand}</h3>
                            </Card.Header>
                            <Card.Body>
                                <div>{p.billing_details.name}</div>
                                <div>{p.card.last4} {p.card.exp_month}/{p.card.exp_year - 2000} </div>
                            </Card.Body>
                        </Card>
                    })}
                </Col>
            </Row>
        </Form>
    </Container>)
}